/**
 * Updates question details based on MCQ responses
 * @param {Array} currentMcqIds - Array of MCQ IDs
 * @param {Array} mcqsResponses - Array of MCQ responses
 * @param {Object} responseDetails - Default response details template
 * @returns {Array} Updated question details
 */
export const updateQuestionDetails = (currentMcqIds, mcqsResponses, responseDetails) => {
  return currentMcqIds.map(mcqId => {
    const existingResponse = mcqsResponses.find(resp => resp.mcq_id === mcqId.id);
    if (existingResponse) {
      const options = existingResponse.selected_options_out.map(option =>
        JSON.stringify({
          id: option.option_id,
          text: option.text,
          order: option.question_order,
        }),
      );
      return {
        id: mcqId.id,
        visited: existingResponse.status.is_seen,
        answered: options.length > 0,
        markedForReview: existingResponse.status.marked_for_review,
        answer: options,
      };
    } else {
      return { ...responseDetails, answer: [], id: mcqId.id };
    }
  });
};
